import React, {useCallback} from 'react';
import { Checkbox as AntdCheckbox } from 'antd';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';


export function CheckBox(props) {
  const { name } = props;
  const [field, meta ,helpers] = useField(name);
  const { t } = useTranslation();

  const { setValue, setTouched } = helpers;
  const { error, touched } = meta;
  const handleChange = useCallback(() => {
    setValue(!field.value)
  }, [setValue, field.value])

  const handleBlur = useCallback(() => {
    setTouched(true, true)
  }, [setTouched, field.value])

  return (
    <AntdCheckbox
      {...props}
      onChange={handleChange}
      // checked={field.value}
    />
  )
}
